import { useState } from "react";
import { IFrequency, IMedication } from "./types";
import { MedicationLogger } from "./MedicationLogger";
import { DateFormatter } from "../../../../shared/utils/DateFormatter";

function MedicationsPopup({
  frequency,
  medication,
  loadData,
  loadHistory,
}: {
  frequency: IFrequency;
  medication: IMedication;
  loadData: () => void;
  loadHistory: any;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [showMedicationAlert, setShowMedicationAlert] = useState(false);

  const handleOpen = (frequency: IFrequency) => {
    setIsOpen(true);
    setShowMedicationAlert(!DateFormatter.scheduleTime(frequency.schedule));
  };

  return (
    <div>
      <div
        onClick={() => handleOpen(frequency)}
        style={{
          textTransform: "capitalize",
          fontSize: "0.875rem",
          color: "var(--color-black)",
          cursor: "pointer",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textAlign: "center",
        }}
      >
        Administer
      </div>
      {isOpen && medication && frequency && (
        <MedicationLogger
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          selectedMedication={medication}
          selectedFrequency={frequency}
          showMedicationAlert={showMedicationAlert}
          setShowMedicationAlert={setShowMedicationAlert}
          loadData={loadData}
          loadHistory={loadHistory}
        />
      )}
    </div>
  );
}

export default MedicationsPopup;
